import { render, staticRenderFns } from "./DeclarationDocumentTable.vue?vue&type=template&id=0479aa24&scoped=true"
import script from "./DeclarationDocumentTable.vue?vue&type=script&lang=ts"
export * from "./DeclarationDocumentTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0479aa24",
  null
  
)

export default component.exports